<template>
  <div class="GeolocationPopup__Wrapper" v-if="showPopUp">
    <div class="GeolocationPopup" :class="settings.store_selector_bg ? 'popupImage' : ''"
      data-section-type="geolocation-popup" aria-hidden="false">
      <div v-if="settings.store_selector_bg" class="GeolocationPopup__Left hidden-pocket"
        v-bind:style="{ backgroundImage: 'url(' + settings.store_selector_bg_url + ')' }">
        <h4 class="Heading u-h4">
          <span v-for="text in translations.geolocation.title.split('#')" :key="text">{{ text }}</span>
        </h4>
      </div>

      <div class="GeolocationPopup__Right GeolocationPopup__Right-Change" v-if="showMarketSelectors">
        <h5 class="GeolocationPopup__Heading Heading u-h5">{{ translations.geolocation.change_country_location }}</h5>

        <form id="localization_form_geolocation" class="GeolocationPopup__LocalizationForm">
          <div class="Form__Select">
            <img class="Country__flag flag" :src="country_flag.replace('TW.svg', 'CN.svg')" alt="Country Flag" />
            <select name="select" title="Select" class="Select_country" @change="getLanguages();"
              v-model="selected_country">
              <option v-for="country in localization.available_countries" :key="country" :value="country.iso_code">
                {{ country.name.replace('Taiwan', 'Taiwan (China)') }} ({{ country.currency.symbol }} {{
                  country.currency.iso_code }})
              </option>
            </select>
          </div>

          <div class="Form__Select" :class="available_languages.length > 1 ? '' : 'hidden'">
            <img class="Language__flag flag" :src="language_flag" alt="Language Flag" />
            <select name="select" title="Select" class="Select_lang" @change="languageChanged()"
              v-model="selected_language">
              <option v-for="language in available_languages" :key="language" :value="language.iso_code">
                {{ language.endonym_name }}
              </option>
            </select>
          </div>

          <button type="button" class="Button Button--primary GeolocationPopup__Save" :disabled="isLoading"
            @click="submit(true)">
            <span v-if="!isLoading">{{ translations.geolocation.save_preferences }}</span>
            <span v-if="isLoading" v-html="icons.loader.outerHTML"></span>
          </button>

          <div class="GeolocationPopup__Cancel"><span @click="closeModal();">
              {{ translations.geolocation.cancel }}</span>
          </div>
        </form>
      </div>

      <div class="GeolocationPopup__Right GeolocationPopup__Right-Confirm" v-if="!showMarketSelectors">

        <img class="GeolocationPopup__Flag" :src="localization.country_flag"
          :alt="'Flag ' + localization.country_iso_code" />

        <h5 class="GeolocationPopup__Heading Heading u-h5">{{ translations.geolocation.we_ship_in }}</h5>

        <p class="GeolocationPopup__Description" v-if="translations.geolocation.description != ''">
          {{ translations.geolocation.description }}</p>

        <ul class="GeolocationPopup__Advantages">
          <li v-for="bullet in translations.geolocation.bullets" :key="bullet">{{ bullet }}</li>
        </ul>

        <button type="button" class="Button Button--primary GeolocationPopup__Save" @click="submit()">{{
          translations.geolocation.continue_in }}</button>

        <div class="GeolocationPopup__Change" @click="showMarketSelectors = true">{{
          translations.geolocation.change_country_location }}</div>
      </div>
    </div>
    <div class="GeolocationPopup__Overlay"></div>
  </div>
</template>

<script>

export default {
  props: {
    settings: {},
    localization: {},
    translations: {}
  },
  data: function () {
    return {
      isLoading: false,
      country_flag: '',
      language_flag: '',
      available_languages: [],
      user_language: false,
      user_country: false,
      selected_country: false,
      selected_language: false,
      redirect_url: false,
      showMarketSelectors: false,
      showPopUp: false,
      icons: window.geolocation_popup.icons
    }
  },
  name: 'GeolocationPopup',
  computed: {},
  async mounted() {
    const user_local_storage = this.getLocalStorageElement('custom_localization');
    const user_browsing_context = await this.getUserInfo();
    let user_settings = {};

    if (user_local_storage) {
      user_settings = user_local_storage.value;
      Object.entries(user_settings).forEach(settings => {
        this[settings[0]] = settings[1]
      })
    }

    if ((!this.user_language || this.user_language != this.localization.language_iso_code) && (this.user_country && this.user_country == this.localization.country_iso_code)) {
      //Language ko and Country ok
      if (!this.user_language) {
        //Language is missing - saving current language
        user_settings["user_language"] = this.localization.language_iso_code;
        this.updateLocalStorageElement("custom_localization", user_settings);
      } else {
        //Language is not correct - redirect
        this.selected_country = this.user_country;
        this.selected_language = this.user_language;
        this.redirectToMarket();
      }
    } else if ((this.user_language && this.user_language == this.localization.language_iso_code) && (!this.user_country || this.user_country != this.localization.country_iso_code)) {
      //Language ok and Country ko
      if (this.user_country) {
        if (this.user_country != this.localization.country_iso_code) {
          //Country ko - redirecting
          this.selected_country = this.user_country;
          this.selected_language = this.user_language;
          this.redirectToMarket();
        }
      } else {
        //Country missing
        if (user_browsing_context.user_country != this.localization.country_iso_code) {
          //Country missing and browser country ko - open pop up
          this.selected_country = user_browsing_context.user_country;
          this.selected_language = this.user_language;
          this.init();
        } else {
          //Country missing but browser country ok - saving current country
          user_settings["user_country"] = this.localization.country_iso_code;
          this.updateLocalStorageElement("custom_localization", user_settings);
        }
      }
    } else if ((!this.user_country || this.user_country != this.localization.country_iso_code) && (!this.user_language || this.user_language != this.localization.language_iso_code)) {
      //Language ko and Country ko

      if (!this.user_country) {
        if (user_browsing_context.user_country != this.localization.country_iso_code) {
          //Country missing and browser country is ko - open pop up
          this.selected_country = user_browsing_context.user_country;
        } else {
          //Country missing but browser country is ok - open pop up
          this.selected_country = this.localization.country_iso_code;
        }
        this.selected_language = this.user_language ? this.user_language : user_browsing_context.user_language;
        this.init();
      } else {
        if (this.user_country != this.localization.country_iso_code) {
          //Country ko - redirect to market
          this.selected_country = this.user_country;
          if (this.user_language) this.selected_language = this.user_language;
          this.redirectToMarket();
        } else {
          //Country ok must be Language ko - saving current language
          user_settings["user_language"] = this.localization.language_iso_code;
          this.updateLocalStorageElement("custom_localization", user_settings);
        }
      }
    } else if (!user_local_storage) {
      //Everything is correct but data is not saved - open pop up
      this.selected_country = user_browsing_context.user_country;
      this.selected_language = user_browsing_context.user_language;
      this.init();
    }
  },
  methods: {
    init() {
      this.country_flag = this.localization.country_flag;
      this.language_flag = this.localization.language_flag;
      this.available_languages = this.localization.available_languages;
      setTimeout(() => { this.showPopUp = true }, 5000);
      if (this.selected_country != this.localization.country_iso_code) {
        this.showMarketSelectors = true;
      }
      this.getLanguages(true);
    },
    async getUserInfo() {
      return await fetch('/browsing_context_suggestions.json')
        .then(response => response.json())
        .then((res) => {
          return {
            user_country: res.detected_values.country.handle,
            user_language: navigator.language.split("-")[0].toLowerCase()
          }
        });
    },
    async getLanguages(change_translations_language = false) {
      this.isLoading = true;
      this.country_flag = this.country_flag.substr(0, this.country_flag.indexOf('.svg') - 2) + this.selected_country + this.country_flag.substr(this.country_flag.indexOf('.svg'));
      this.available_languages = [];
      const targetMarketUrl = await this.getTargetMarketUrl('/');
      this.redirect_url = targetMarketUrl.url;

      const responseDocument = document.createElement('html');
      responseDocument.innerHTML = targetMarketUrl.text;

      const languagesWrapper = responseDocument.querySelector('#footer-locale-popover');
      const translationsCopyElement = responseDocument.querySelector('#geolocation-popup-payload');
      const translationCopyObject = translationsCopyElement ? JSON.parse(translationsCopyElement.textContent) : {};
      if (languagesWrapper) {
        const languages = languagesWrapper.querySelectorAll('[name="locale_code"]');
        this.available_languages = Array.from(languages).map(item => { return { endonym_name: item.innerText, iso_code: item.value } });
        this.selected_language = Array.from(languages).filter(lang => { if (lang.classList.contains('is-selected')) return lang })[0].value;
        this.changeLanguageFlag();
      } else {
        let language = translationCopyObject.localization.language_iso_code;
        let item = [];
        item['endonym_name'] = language;
        item['iso_code'] = language;
        this.available_languages[0] = item;
        this.selected_language = language;
      }

      if (change_translations_language) {
        let translated_texts = translationCopyObject.translations;
        this.changeTranslationLanguage(translated_texts);
      }

      this.isLoading = false;
    },
    changeTranslationLanguage(translations) {
      this.translations = translations;
    },
    languageChanged() {
      this.redirect_url = false;
      this.selected_market = false;
      this.changeLanguageFlag();
    },
    changeLanguageFlag() {
      this.language_flag = this.language_flag.substr(0, this.language_flag.indexOf('.svg') - 2) + this.selected_language.toUpperCase() + this.language_flag.substr(this.language_flag.indexOf('.svg'));
    },
    closeModal() {
      this.showPopUp = false;
    },
    submit(redirect = false) {
      this.saveLocalStorageElement();
      if (redirect) this.redirectToMarket(this.selected_language, this.selected_country);
      this.closeModal();
    },
    saveLocalStorageElement() {
      const user_settings = {
        user_country: this.selected_country,
        user_language: this.selected_language
      }
      this.updateLocalStorageElement('custom_localization', user_settings);
    },
    async redirectToMarket() {
      const return_url = this.getReturnUrl();
      if (Shopify.designMode) return;
      if (localStorage.getItem('has_redirected')) {
        localStorage.removeItem('has_redirected');
        this.init();
        return;
      }
      if (this.redirect_url) {
        if (this.redirect_url.slice(-1) != '/' && return_url != '/') {
          this.redirect_url = this.redirect_url + '/';
        }
        localStorage.setItem('has_redirected', 'true');
        window.location.href = this.redirect_url + return_url;
      } else {
        try {
          /* If user has not select a market and the user hasn't chosen one previously or the market cookie has been removed,
          we ask Shopify which is the right link to redirect to */
          const targetMarketUrl = await this.getTargetMarketUrl(return_url);
          localStorage.setItem('has_redirected', 'true');
          window.location.href = targetMarketUrl.url;
        } catch (error) {
          console.log(error);
        }
      }
    },
    getTargetMarketUrl(return_url) {
      this.isLoading = true;
      let market_url;

      let formData = new FormData();
      formData.append('country_code', this.selected_country);
      if (this.selected_language) formData.append('locale_code', this.selected_language);
      formData.append('form_type', 'localization');
      formData.append('_method', 'put');
      formData.append('return_to', return_url);

      return fetch(location.origin + '/localization', {
        body: formData,
        method: 'POST',
      }).then(response => {
        market_url = response.url
        return response.text()
      })
        .then(data => {
          return {
            url: market_url,
            text: data
          }
        })
    },
    getReturnUrl() {
      let param = '',
        return_url = '';
      if (location.href.indexOf('?') != -1) param = location.href.slice(location.href.indexOf('?'));
      //Remove previous market
      if (location.pathname.search(/(\/[A-Za-z]{2,3}-[A-Za-z]{2,3}\/)/g) != -1) {
        return_url = location.pathname.replace(/(\/[A-Za-z]{2,3}-[A-Za-z]{2,3}\/)/g, '') + param;
      } else if (location.pathname.search(/(\/[A-Za-z]{2,3}-[A-Za-z]{2,3})$/g) != -1) {
        return_url = location.pathname.replace(/(\/[A-Za-z]{2,3}-[A-Za-z]{2,3})$/g, '') + param;
      } else if (location.pathname.search(/(\/[A-Za-z]{2,3}\/)/g) != -1) {
        return_url = location.pathname.replace(/(\/[A-Za-z]{2,3}\/)/g, '') + param;
      } else if (location.pathname.search(/(\/[A-Za-z]{2,3})$/g) != -1) {
        return_url = location.pathname.replace(/(\/[A-Za-z]{2,3})$/g, '') + param;
      } else {
        return_url = location.pathname + param;
      }

      return return_url;
    },
    getLocalStorageElement(key) {
      const itemString = localStorage.getItem(key);
      if (itemString) {
        const item = JSON.parse(itemString);
        if (!item.expires) {
          return item;
        } else {
          const now = new Date.getTime();
          if (item.expires > now) {
            return item;
          } else {
            localStorage.removeItem(key);
            return null
          }
        }
      }
      return null
    },
    updateLocalStorageElement(key, value, name) {
      let item = this.getLocalStorageElement(key);

      if (name && key) {
        if (!item) {
          const obj = {};
          obj[name] = value;
          item = {
            value: obj
          }
        } else {
          item.value[name] = value;
        }
      } else {
        item = {
          value: value
        }
      }

      localStorage.setItem(key, JSON.stringify(item));
    },
    deleteLocalStorageElement(key, name) {
      if (name) {
        const item = this.getLocalStorageElement(key);
        if (item) {
          delete item.value[name];
          localStorage.setItem(key, JSON.stringify(item));
        }
      } else {
        localStorage.removeItem(key);
      }
    }
  }
};
</script>
